import { withInstall } from '../utils'
import _Circle from './Circle'
import './index.scss'
export const Circle = withInstall(_Circle)
export default Circle
